<template>
  <div>
    <header-top></header-top>
    <div class="background">
      <div class="container">
        <div class="leftWrapper">
          <ul>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.关于MANA') }"
                >&#xe6b0;</i>
                <span class="titleWord">{{$t('about.关于MANA')}}</span>
              </a>
            </li>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.用户协议') }"
                >&#xe7fb;</i>
                <span class="titleWord">{{$t('about.用户协议')}}</span>
              </a>
            </li>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon specialicon"
                  :class="{ active: leftTitle===$t('about.免责声明') }"
                >&#xe667;</i>
                <span class="titleWord">{{$t('about.免责声明')}}</span>
              </a>
            </li>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.侵权申诉') }"
                >&#xe65a;</i>
                <span class="titleWord">{{$t('about.侵权申诉')}}</span>
              </a>
            </li>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.帮助中心') }"
                >&#xe600;</i>
                <span class="titleWord">{{$t('about.帮助中心')}}</span>
              </a>
            </li>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.联系我们') }"
                >&#xe604;</i>
                <span class="titleWord">{{$t('about.联系我们')}}</span>
              </a>
            </li>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.投稿须知') }"
                >&#xe779;</i>
                <span class="titleWord">{{$t('about.投稿须知')}}</span>
              </a>
            </li>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.常见问题') }"
                >&#xe612;</i>
                <span class="titleWord">{{$t('about.常见问题')}}</span>
              </a>
            </li>
            <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.版权声明') }"
                >&#xe67e;</i>
                <span class="titleWord">{{$t('about.版权声明')}}</span>
              </a>
            </li>
            <!-- <li class="titleItem" @click="handleClickGetDom">
              <a href="javascript:;">
                <i
                  class="iconfont titleIcon"
                  :class="{ active: leftTitle===$t('about.法律责任') }"
                >&#xe67f;</i>
                <span class="titleWord">{{$t('about.法律责任')}}</span>
              </a>
            </li> -->
          </ul>
        </div>
        <div class="rightWrapper">
          <div
            class="rightContent"
            v-for="item of list"
            :key="item.id"
            v-show="item.title === leftTitle"
          >
            <h2 v-html="item.title"></h2>
            <div v-html="item.body" class="bodyContent"></div>
          </div>
        </div>
      </div>
    </div>
    <footer-down class="aboutFooter"></footer-down>
  </div>
</template>

<script>
import HeaderTop from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";
export default {
  name: "about",
  metaInfo() {
    return {
      title: this.$t("global.关于我们") + " | MANA"
    };
  },
  data() {
    return {
      list: [],
      leftTitle: decodeURI(this.$route.params.title),
      iconColor: false
    };
  },
  components: {
    HeaderTop,
    FooterDown
  },
  watch: {
    $route(to,from){
        this.leftTitle = this.$route.params.title
    }
  },
  methods: {
    getAboutInfo(title) {
      this.$http
        .get("/api/common/page", {
          params: {
            title
          }
        })
        .then(this.getAboutInfoSucc);
    },
    getAboutInfoSucc(res) {
      const data = res.data || {};
      if (!data.body) {
        data.body = `<p>${this.$t("global.内容制作中")}，${this.$t(
          "global.敬请期待"
        )}！</p>`;
      }
      this.list.push(res.data || {});
    },
    handleClickGetDom(e) {
      this.leftTitle = e.currentTarget.children[0].children[1].innerHTML;
    }
  },
  mounted() {
    const titleList = document.getElementsByClassName("titleWord");
    for (let i = 0; i < titleList.length; i++) {
      this.getAboutInfo(titleList[i].innerHTML);
    }
  }
};
</script>

<style lang="stylus" scoped>
.rightWrapper >>> h2 {
  font-size: 16px;
  border-left: 4px solid #0060ff;
  padding-left: 10px;
  margin-bottom: 30px;
}

.rightWrapper >>> .else-page-contentBox {
  margin-bottom: 30px;
}

.rightWrapper >>> p {
  color: #7d7d7d;
  font-size: 14px;
  line-height: 25px;
  margin-bottom: 10px;
}

.rightWrapper >>> span {
  display: block;
}

.rightWrapper >>> .font-weight {
  font-weight: bold;
}

.bodyContent >>> img {
  display: block;
  width: 100%;
}

.background {
  width: 100%;
  height: auto;
  min-height: 485px;
  background: #f4f4f4;

  .container {
    padding: 40px 0;
    display: flex;
    flex-direction: row;

    &:after {
      content: '';
      display: block;
      clear: both;
    }

    .leftWrapper {
      width: 240px;
      float: left;
      background: #fafafa;
      padding: 40px 20px;
      margin-right: 0.32rem;
      box-shadow: 0 0 0.08rem 0 rgb(213, 213, 213);
      box-sizing: border-box;

      .titleItem {
        display: block;
        width: 100%;
        position: relative;

        a {
          display: inline-block;
          padding-bottom: 55px;

          &:after {
            content: '';
            display: block;
            width: 2.18rem;
            height: 0.014rem;
            background: #fafafa;
            position: absolute;
            left: -20px;
            bottom: 0.4rem;
          }

          &:hover {
            &:after {
              background: #0060ff;
            }
          }

          .titleIcon {
            display: inline-block;
            font-size: 0.3rem;
            line-height: 0.27rem;
            margin-right: 0.18rem;
            color: #a0a0a0;
            vertical-align: middle;
          }

          .specialicon {
            transform: scale(1.8);
            margin-left: -0.04rem;
            margin-right: 0.24rem;
          }

          .titleWord {
            display: inline-block;
            vertical-align: middle;
            font-size: 0.19rem;
            color: #313131;
            line-height: 0.27rem;
            box-sizing: border-box;
          }
        }
      }
    }

    .rightWrapper {
      flex: 1;
      background: #ffffff;
      padding: 0.42rem;
      box-shadow: 0 0 0.08rem 0 rgb(213, 213, 213);
      box-sizing: border-box;
      min-height: 12.4rem !important;

      .rightContent {
        width: 100%;
        padding: 0.38rem 0.21rem;
        margin: 0 auto;
        max-width: 100%;
      }
    }
  }
}

.aboutFooter {
  position: relative !important;
}

.active {
  color: #0060ff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/page/about.vue